const LoadingSpinner = () => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden">
            <style>{`
                @keyframes drawPath {
                    to { stroke-dashoffset: 0; }
                }

                @keyframes fillInGold {
                    from { fill: transparent; }
                    to { fill: #C8972A; }
                }

                @keyframes logoPulse {
                    0%, 100% {
                        filter: drop-shadow(0 0 6px rgba(200,151,42,0.5));
                    }
                    50% {
                        filter: drop-shadow(0 0 18px rgba(200,151,42,0.85));
                    }
                }

                @keyframes rotateRingCW {
                    from { transform: rotate(0deg); }
                    to   { transform: rotate(360deg); }
                }

                @keyframes rotateRingCCW {
                    from { transform: rotate(0deg); }
                    to   { transform: rotate(-360deg); }
                }

                @keyframes fadeUp {
                    from { opacity: 0; transform: translateY(14px); }
                    to   { opacity: 1; transform: translateY(0); }
                }

                @keyframes dotBounce {
                    0%, 60%, 100% { transform: translateY(0);    opacity: 0.35; }
                    30%           { transform: translateY(-5px); opacity: 1; }
                }

                @keyframes shimmerText {
                    0%   { background-position: 200% center; }
                    100% { background-position: -200% center; }
                }

                @keyframes gridBreath {
                    0%, 100% { opacity: 1; }
                    50%      { opacity: 0.4; }
                }

                /* ── Background ── */
                .ls-bg {
                    background: radial-gradient(
                        ellipse at 50% 40%,
                        #0c1e36 0%,
                        #041c32 55%,
                        #020e1c 100%
                    );
                }

                .ls-grid {
                    background-image:
                        linear-gradient(rgba(200,151,42,0.04) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(200,151,42,0.04) 1px, transparent 1px);
                    background-size: 56px 56px;
                    animation: gridBreath 5s ease-in-out infinite;
                }

                /* ── Logo paths ── */
                .logo-path {
                    stroke: #C8972A;
                    stroke-width: 3;
                    fill: none;
                    stroke-dasharray: 3000;
                    stroke-dashoffset: 3000;
                    animation:
                        drawPath   2.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards,
                        fillInGold 1.2s ease 2.2s forwards,
                        logoPulse  2.8s ease-in-out infinite 3.6s;
                }

                /* ── Rings ── */
                .ring-cw  { animation: rotateRingCW  9s linear infinite; transform-origin: center; }
                .ring-ccw { animation: rotateRingCCW 6s linear infinite; transform-origin: center; }

                /* ── Card ── */
                .ls-card {
                    animation: fadeUp 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
                    background: rgba(4, 20, 40, 0.78);
                    border: 1px solid rgba(200,151,42,0.22);
                    backdrop-filter: blur(28px);
                    -webkit-backdrop-filter: blur(28px);
                    box-shadow:
                        0 30px 70px rgba(0,0,0,0.65),
                        0 0 0 1px rgba(255,255,255,0.03),
                        inset 0 1px 0 rgba(255,255,255,0.04);
                }

                /* ── Staggered children ── */
                .ls-label { animation: fadeUp 0.7s cubic-bezier(0.16,1,0.3,1) 0.12s both; }
                .ls-dots  { animation: fadeUp 0.7s cubic-bezier(0.16,1,0.3,1) 0.28s both; }

                /* ── Dots ── */
                .dot-1 { animation: dotBounce 1.3s ease-in-out infinite 0.0s; }
                .dot-2 { animation: dotBounce 1.3s ease-in-out infinite 0.18s; }
                .dot-3 { animation: dotBounce 1.3s ease-in-out infinite 0.36s; }

                /* ── Shimmer text ── */
                .ls-shimmer {
                    background: linear-gradient(
                        90deg,
                        rgba(148,163,184,0.45) 0%,
                        #C8972A 30%,
                        #F0C060 50%,
                        #C8972A 70%,
                        rgba(148,163,184,0.45) 100%
                    );
                    background-size: 200% auto;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    animation: shimmerText 3.5s linear infinite;
                }

                /* ── Corner brackets ── */
                .corner { position: absolute; width: 14px; height: 14px; }
                .corner-tl { top: 14px; left: 14px;
                    border-top:  1px solid rgba(200,151,42,0.5);
                    border-left: 1px solid rgba(200,151,42,0.5); }
                .corner-tr { top: 14px; right: 14px;
                    border-top:   1px solid rgba(200,151,42,0.5);
                    border-right: 1px solid rgba(200,151,42,0.5); }
                .corner-bl { bottom: 14px; left: 14px;
                    border-bottom: 1px solid rgba(200,151,42,0.5);
                    border-left:   1px solid rgba(200,151,42,0.5); }
                .corner-br { bottom: 14px; right: 14px;
                    border-bottom: 1px solid rgba(200,151,42,0.5);
                    border-right:  1px solid rgba(200,151,42,0.5); }
            `}</style>

            {/* ── Background layers ── */}
            <div className="ls-bg absolute inset-0" />
            <div className="ls-grid absolute inset-0" />

            {/* ── Ambient glow behind card ── */}
            <div
                className="absolute pointer-events-none"
                style={{
                    width: "480px",
                    height: "480px",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    background:
                        "radial-gradient(circle, rgba(200,151,42,0.08) 0%, transparent 65%)",
                }}
            />

            {/* ── Card ── */}
            <div
                className="ls-card relative flex flex-col items-center gap-7 px-12 py-10 rounded-2xl"
                style={{ minWidth: "340px" }}
            >
                {/* Corner brackets */}
                <div className="corner corner-tl" />
                <div className="corner corner-tr" />
                <div className="corner corner-bl" />
                <div className="corner corner-br" />

                {/* ── Top label ── */}
                <div className="ls-label flex items-center gap-3">
                    <div
                        style={{
                            width: "28px",
                            height: "1px",
                            background:
                                "linear-gradient(to right, transparent, rgba(200,151,42,0.65))",
                        }}
                    />
                    <span
                        style={{
                            fontSize: "10px",
                            letterSpacing: "0.28em",
                            textTransform: "uppercase",
                            fontWeight: 500,
                            color: "rgba(200,151,42,0.75)",
                        }}
                    >
                        Portfolio
                    </span>
                    <div
                        style={{
                            width: "28px",
                            height: "1px",
                            background:
                                "linear-gradient(to left, transparent, rgba(200,151,42,0.65))",
                        }}
                    />
                </div>

                {/* ── Logo + rotating rings ── */}
                <div
                    className="relative flex items-center justify-center"
                    style={{ width: "220px", height: "130px" }}
                >
                    {/* Outer dashed ring */}
                    <svg
                        viewBox="0 0 240 140"
                        className="ring-cw"
                        style={{
                            width: "270px",
                            height: "158px",
                            position: "absolute",
                        }}
                        overflow="visible"
                    >
                        <defs>
                            <linearGradient
                                id="outerRingGrad"
                                x1="0%"
                                y1="0%"
                                x2="100%"
                                y2="100%"
                            >
                                <stop
                                    offset="0%"
                                    stopColor="#C8972A"
                                    stopOpacity="0.9"
                                />
                                <stop
                                    offset="45%"
                                    stopColor="#C8972A"
                                    stopOpacity="0.08"
                                />
                                <stop
                                    offset="100%"
                                    stopColor="#C8972A"
                                    stopOpacity="0.9"
                                />
                            </linearGradient>
                        </defs>
                        <ellipse
                            cx="120"
                            cy="70"
                            rx="115"
                            ry="65"
                            fill="none"
                            stroke="url(#outerRingGrad)"
                            strokeWidth="0.8"
                            strokeDasharray="4 8"
                        />
                    </svg>

                    {/* Inner dashed ring */}
                    <svg
                        viewBox="0 0 240 140"
                        className="ring-ccw"
                        style={{
                            width: "248px",
                            height: "146px",
                            position: "absolute",
                        }}
                        overflow="visible"
                    >
                        <defs>
                            <linearGradient
                                id="innerRingGrad"
                                x1="100%"
                                y1="0%"
                                x2="0%"
                                y2="100%"
                            >
                                <stop
                                    offset="0%"
                                    stopColor="#C8972A"
                                    stopOpacity="0.5"
                                />
                                <stop
                                    offset="50%"
                                    stopColor="#C8972A"
                                    stopOpacity="0.04"
                                />
                                <stop
                                    offset="100%"
                                    stopColor="#C8972A"
                                    stopOpacity="0.5"
                                />
                            </linearGradient>
                        </defs>
                        <ellipse
                            cx="120"
                            cy="70"
                            rx="108"
                            ry="60"
                            fill="none"
                            stroke="url(#innerRingGrad)"
                            strokeWidth="0.5"
                            strokeDasharray="7 14"
                        />
                    </svg>

                    {/* NG Logo */}
                    <svg
                        style={{
                            width: "200px",
                            height: "auto",
                            position: "relative",
                            zIndex: 1,
                        }}
                        viewBox="0 0 1322 734"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        overflow="visible"
                    >
                        <defs>
                            <filter
                                id="logoGlow"
                                x="-25%"
                                y="-25%"
                                width="150%"
                                height="150%"
                            >
                                <feGaussianBlur
                                    stdDeviation="14"
                                    result="blur"
                                />
                                <feMerge>
                                    <feMergeNode in="blur" />
                                    <feMergeNode in="SourceGraphic" />
                                </feMerge>
                            </filter>
                        </defs>
                        <path
                            className="logo-path"
                            filter="url(#logoGlow)"
                            d="M34.3047 717C11.5182 717 0.125 704.793 0.125 680.379V53.4258C0.125 29.0117 11.5182 16.8047 34.3047 16.8047H106.57C134.565 16.8047 155.724 28.1979 170.047 50.9844L419.07 450.887H422.488C420.861 431.355 420.047 411.824 420.047 392.293V53.4258C420.047 29.0117 431.44 16.8047 454.227 16.8047H528.445C551.232 16.8047 562.625 29.0117 562.625 53.4258V680.379C562.625 704.793 551.232 717 528.445 717H461.062C433.068 717 411.909 705.607 397.586 682.82L143.68 275.594H140.262C141.889 295.125 142.703 314.656 142.703 334.188V680.379C142.703 704.793 131.31 717 108.523 717H34.3047Z"
                        />
                        <path
                            className="logo-path"
                            filter="url(#logoGlow)"
                            d="M682.742 366.902C682.742 254.598 712.039 165.405 770.633 99.3242C829.227 33.2435 912.234 0.203125 1019.66 0.203125C1084.43 0.203125 1135.22 8.50391 1172 25.1055C1209.11 41.707 1241.66 67.4232 1269.66 102.254C1286.58 123.413 1286.1 139.852 1268.19 151.57L1212.53 187.703C1196.25 198.445 1178.84 193.725 1160.28 173.543C1144.98 156.941 1125.61 143.107 1102.18 132.039C1078.74 120.971 1052.86 115.438 1024.54 115.438C956.18 115.438 907.514 137.085 878.543 180.379C849.572 223.348 835.086 285.522 835.086 366.902C835.086 448.283 849.572 510.62 878.543 553.914C907.514 596.883 956.18 618.367 1024.54 618.367C1057.74 618.367 1086.39 615.112 1110.48 608.602C1134.57 601.766 1157.35 589.559 1178.84 571.98V484.578H1072.88C1048.46 484.578 1036.26 473.999 1036.26 452.84V395.223C1036.26 374.064 1048.46 363.484 1072.88 363.484H1284.79C1309.21 363.484 1321.41 374.064 1321.41 395.223V643.27C1275.84 676.798 1229.78 700.236 1183.23 713.582C1137.01 726.928 1082.48 733.602 1019.66 733.602C913.862 733.602 831.18 700.561 771.609 634.48C712.365 568.4 682.742 479.207 682.742 366.902Z"
                        />
                    </svg>
                </div>

                {/* ── Loading indicator ── */}
                <div className="ls-dots flex flex-col items-center gap-3">
                    <div className="flex items-center gap-2">
                        <div
                            className="dot-1 rounded-full"
                            style={{
                                width: "5px",
                                height: "5px",
                                backgroundColor: "#C8972A",
                            }}
                        />
                        <div
                            className="dot-2 rounded-full"
                            style={{
                                width: "5px",
                                height: "5px",
                                backgroundColor: "#C8972A",
                            }}
                        />
                        <div
                            className="dot-3 rounded-full"
                            style={{
                                width: "5px",
                                height: "5px",
                                backgroundColor: "#C8972A",
                            }}
                        />
                    </div>
                    <span
                        className="ls-shimmer"
                        style={{
                            fontSize: "9px",
                            letterSpacing: "0.25em",
                            textTransform: "uppercase",
                            fontWeight: 400,
                        }}
                    >
                        Initializing
                    </span>
                </div>
            </div>
        </div>
    );
};

export default LoadingSpinner;
